/**
 * Global JS env.
 *
 * @global
 *
 * @namespace
 */
 (function (drupalSettings) {
  "use strict";

  Drupal.behaviors.env = {
    attach: function () {

      /**
       * Test touch capabilities of user agent.
       *
       * @returns {Bool}
       */
       const isTouch = function() {
        return (('ontouchstart' in window) ||       // html5 browsers
                (window.navigator.maxTouchPoints > 0) ||   // IE 11+
                (window.navigator.msMaxTouchPoints > 0));  // IE10
      };

      /**
       * Determine the operating system.
       *
       * @returns {String}
       */
       const getOS =  function() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
          return "windowsphone";
        }
        if (/android/i.test(userAgent)) {
          return "android";
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          return "ios";
        }
        if (/mac/i.test(userAgent)) {
          return "macos";
        }
        if (/win/i.test(userAgent)) {
          return "windows";
        }
        return "unknown";
      };

      // Add env vars to global drupalSettings
      drupalSettings.env.isTouch = isTouch();
      drupalSettings.env.os = getOS();
    }
  };
})(drupalSettings);
